/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ShiMing2.vue?vue&type=template&id=1648312f&scoped=true&"
import script from "./ShiMing2.vue?vue&type=script&lang=js&"
export * from "./ShiMing2.vue?vue&type=script&lang=js&"
import style0 from "./ShiMing2.vue?vue&type=style&index=0&id=1648312f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1648312f",
  null
  
)

export default component.exports